/**
 * Schermteksten in het Chinees.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const zh: Teksten = {
  kamerOphalen: "正在获取房间…",
  kamerWerktNiet: "该房间无法使用",
  serverReageertNiet: "服务器无响应",
  probeerOpnieuw: "重试",
  vraagNieuweCode: "请向分享代码的人索取新代码。房间会在几小时后失效。",
  welkeTaalSprekJij: "你讲哪种语言？",
  jouwStem: "翻译中你的声音",
  man: "男声",
  vrouw: "女声",
  pincode: "PIN码",
  pincodeUitleg: "你可以向分享代码的人获取。",
  gaDeKamerIn: "进入房间",
  kiesEerstJeTaal: "请先选择你的语言",
  microfoonAanvragen: "正在申请麦克风…",
  toestemmingUitleg: "浏览器稍后会请求麦克风权限。如果不允许，你将只能打字。",
  microfoonTestLink: "先测试麦克风",
  stemGaatMee: "在此房间中，对方除了听到翻译，也会听到你的原声。",
  alleenChatMelding: "此对话仅限聊天。你输入消息并阅读译文；不会朗读任何内容。",
  verlooptOm: "失效时间：",
  nooitVasteKamer: "永不过期，固定房间",
  kamer: "房间",
  tolkgesprek: "同声翻译",
  juisteKamer: "你已进入正确的房间。稍后即可在此参与对话。",
  jij: "你",
  deAnder: "对方",
  verbinden: "连接中…",
  verbonden: "已连接",
  verbindingKwijt: "连接丢失。正在重试…",
  wachtenOpAnder: "你已进入房间。等待对方扫描QR码。",
  allebeiInDeKamer: "你们双方都已进入房间。",
  anderIsWeg: "对方已离开",
  anderSpreekt: "对方正在说话…",
  jeKuntErNietIn: "你无法进入",
  overgenomenTitel: "已在其他设备上继续",
  overgenomenUitleg: "此对话刚刚在另一个设备上打开。请在旧设备之外继续通话。",
  terug: "返回",
  geluidStaatUit: "声音已静音。请轻按屏幕任意位置。",
  tikHier: "轻按这里",
  bewaardTot: '保存至 {tijd}',
  bewaardVast: "固定房间。消息保留 30 天。",
  spreekIn: "请说话",
  luisteren: "正在聆听…轻按以停止",
  uitschrijven: "正在转写…",
  tijdOmTeVerbeteren: "修改时间",
  altijdZelfVersturen: "始终手动检查并发送",
  jijVerstuurtZelf: "由你手动发送",
  uit: "关",
  sec: "秒",
  vertalingMeteenAfspelen: "立即播放翻译",
  typHierJeBericht: "在此输入你的消息…",
  stuur: "发送",
  geenOpnameMogelijk: "此浏览器无法录音。你可以使用打字输入。",
  verstaanAls: "识别为",
  tellerStaatStil: "计时器已暂停",
  versturen: "发送",
  wis: "清除",
  jijZei: "你说了",
  vertaald: "已翻译",
  duimOmhoog: "准确",
  duimOmlaag: "不准确",
  opnieuwProberenKnop: "使用更佳模型重试",
  opnieuwProberenBezig: "正在重新翻译…",
  duimTranscriptWoordenlijstUitnodiging: "识别有误？将其加入词汇表纠正：",
  instellingenAanpassen: "调整设置",
  geldtVoorJullieBeiden: "适用于双方",
  alleenVoorJou: "仅适用于你",
  stuurMijnStemMee: "发送我的原声",
  verbeterSpelfouten: "纠正我文本中的拼写错误",
  verbeterSpelfoutenUit: "关闭此项将显示实际识别到的内容，包含错误。",
  alleenChat: "仅聊天：无语音，无麦克风",
  alleenChatUitleg: "你们都用打字。会显示译文和原文；不会朗读任何内容。",
  aangepastDoorDeAnder: "对方更改了设置。",
  foutSpraak: "翻译已生成，但没有语音输出。",
  foutSpraakQuota: "今天的语音额度已用尽。文字功能正常，语音将在明天恢复。",
  foutBudgetKamer: "本次对话已达到上限，翻译暂停。创建对话的人可以提高上限，之后会立即恢复。",
  foutBudgetMaand: "本应用的月度预算已用完。管理员调整后，翻译才会恢复。",
  foutTaal: "无法使用该语言：你们不能都说同一种语言。",
  origineel: "原文",
  vertalen: "翻译中…",
  vertalenMislukt: "翻译失败。",
  opnieuwAfspelen: "重新播放翻译",
  hoorDeAnder: "听听对方的原声",
  woordenlijst: "纠错词汇表",
  woordenlijstUitleg: "如果应用经常听错某个名字或专业术语？请在此处设定其正确含义。",
  hijHoort: "应用听成…",
  jijBedoelt: "你的意思…",
  ookVolgendeGesprekken: "后续对话中也有效 — 否则仅对本次对话生效",
  voegToe: "添加",
  bezig: "处理中…",
  lijstNietGeladen: "无法加载列表。",
  toevoegenMislukt: "添加失败。",
  verwijderenMislukt: "删除失败。",
  overal: "全局有效",
  verwijder: "删除",
  overDitGesprek: "关于此对话",
  toon: "翻译语气",
  sfeer: "对话氛围",
  jouwPlek: "你的位置",
  hoeHetWerkt: "服务器会转换你的录音并一次性完成翻译。你的原声也会传给对方。",
  kleinereTekst: "缩小字体",
  grotereTekst: "放大字体",
  insprekenVerbergen: "隐藏语音输入",
  insprekenTonen: "显示语音输入",
  toetsenbordVerbergen: "隐藏键盘",
  toetsenbordTonen: "显示键盘",
  vormAutomatisch: "自动",
  vormInformeel: "非正式",
  vormFormeel: "正式",
  sfeerNeutraal: "中立",
  sfeerZakelijk: "商务",
  sfeerOfficieel: "官方",
  sfeerVriendschappelijk: "友好",
  sfeerPartner: "伴侣",
  foutKamerVol: "该房间已满。最多只能容纳两人。",
  plekBezetTitel: "你的位置已被占用",
  plekBezetUitleg: "这场对话中你这一侧已经有人在用你的语言。通常就是你自己：对话还开在另一台设备或另一个标签页里。在那边关掉后再试一次。有时要过一分半钟位置才会空出来。",
  plekBezetWissel: "是你自己吗？输入 WISSEL，把对话转到这台设备上。另一台设备随后会关闭。",
  plekBezetKnop: "转到这台设备",
  foutKamerVerlopen: "该房间已过期或已关闭。",
  foutKamerOnbekend: "该房间不存在。",
  foutPinNodig: "该房间需要输入PIN码。",
  foutPinFout: "PIN码不正确。",
  foutProtocol: "应用与服务器无法通信。请刷新页面。",
  foutMicroGeweigerd: "你拒绝了麦克风权限。请轻按地址栏中的锁图标重新启用。",
  foutGeenMicro: "未找到麦克风。请连接麦克风后重试。",
  foutMicroInGebruik: "麦克风正被其他程序占用。请关闭该程序并重试。",
  foutGeenHttps: "麦克风仅在安全连接下工作。请通过 https 访问此页面。",
  foutMicroOnbekend: "无法启动麦克风。",
  foutNietsOpgenomen: "未录制任何内容。你的麦克风开启了吗？",
  foutNietsGehoord: "没有听到声音。你的麦克风开启了吗？说话声音够大吗？",
  foutOpnameTeLang: "录音时间过长。请简短地分段说话。",
  foutMicroGedempt: "你的麦克风已被静音。请取消静音后重试。",

  // --- microfoontest ---
  micTitel: "麦克风测试",
  micOnderschrift: "连续四项测试，每项五秒。全程持续说话。",
  micStart: "开始测试",
  micTest1: "1. 仅识别",
  micTest2: "2. 仅录音",
  micTest3: "3. 同时 — 先录音",
  micTest4: "4. 同时 — 先识别",
  micFase1: "第 1 项，共 4 项：仅识别 — 说一句短句",
  micFase2: "第 2 项，共 4 项：仅录音 — 继续说",
  micFase3: "第 3 项，共 4 项：先录音，再识别 — 继续说",
  micFase4: "第 4 项，共 4 项：先识别，再录音 — 继续说",
  micKlaar: "完成",
  micGehoord: "听到",
  micOpnameformaat: "录音格式",
  micGeen: "无",
  micBeveiligd: "安全连接",
  micJa: "是",
  micNee: "否",
  micBrowser: "浏览器",
  micGeenHttps: "没有 https，浏览器不会开放麦克风。在 localhost 上可以。",
  micGeenHerkenning: "此浏览器不支持语音识别。",
  micZegIets: "说点什么…",
  micWoordenBinnen: "正在收到文字",
  micKonNietStarten: "无法启动",
  micGeenRecorder: "此浏览器不支持 MediaRecorder。",
  micOpnemen: "录音中…",
  micNietsOpgenomen: "没有录到任何内容",
  micGeenMicrofoon: "没有麦克风",
  micOpnameEerst: "先录音…",
  micHerkenningEerst: "先识别…",
  micOpnameStarttNiet: "录音没有启动",
  micSamenGelukt: "同时成功。录音 {kb} kB。",
  micAlleenOpname: "录音成功，识别失败。",
  micAlleenHerkenning: "识别成功，录音失败。",
  micGeenVanBeide: "两者都没有。",
  micNetwerkFout: "语音识别无法连接服务器。",
  micAfgebroken: "录音已中断。",
  verslagTitel: "对话记录",
  verslagWie: "发言人",
  verslagOrigineel: "原文",
  verslagVertaling: "译文",
  verslagSpreker: "发言人 {x}",
  verslagBerichten: "消息",
  verslagGemaaktOp: "创建时间",
  verslagGeenOpname: "并非逐字录音。",
  verslagNootOrigineel: "“原文”是应用所理解的发言人内容。",
  verslagNootCorrectie: "拼写纠正已开启：细小的输入错误已被更正。",
  verslagNootAangepast: "发言人在发送前仍可修改文本。",
  verslagGesproken: "语音",
  verslagGetypt: "打字",
  verslagMislukt: "翻译失败。对方没有看到这句话的本国语言版本。",
  verslagNietKlaar: "生成本记录时，翻译尚未完成。",
  verslagVertrouwelijk: "机密。",
  verslagAlleenDeelnemers: "本记录包含一次私人对话的内容，仅供参与者使用。",
  verslagGewist: "对话删除时间：{tijd}。此后将无法重新生成本记录。",
  verslagGewistVast: "固定房间：每条消息在发送 30 天后删除。更早的消息不在本记录中。",
};
